angular.module('picmonicpublic')
    .controller('comprehensiveCoverageController', ['MarketOptionsConfig', 'Picmonics', 'UserService', '$http', '$scope', '$anchorScroll', '$timeout', function(MarketOptionsConfig, Picmonics, UserService, $http, $scope, $anchorScroll, $timeout){
        $scope.markets = MarketOptionsConfig.markets;
        $scope.UserService = UserService;

        $scope.$parent.seen.comprehensivecoverage = 1;

        $http.get('/api/v3/pathways/courses').then(function(response){
            $scope.pathways = response.data;
        });

        $scope.openSection = function(market) {
            if ($scope.openMarket) {
                $timeout(function(){
                    var offset = $anchorScroll.yOffset;
                    offset = 64;
                    $anchorScroll(market.slug);
                    $anchorScroll.yOffset = offset;
                }, 0);
            }
            $scope.openMarket = $scope.openMarket == market.id ? false : market.id;
        };

        $scope.search = function(market_id, searchTerm) {
            UserService.setMarketCookies(market_id);
            $scope.searching = true;

            $scope.results = Picmonics.search({
                source: 'find-picmonic',
                query: searchTerm,
                page: 1,
                searchPicmonics: true,
                searchPathways: true,
                searchBreadcrumbs: true,
                sort_by: 'relevance',
                include_ugc: false,
                quick: 1
            });

            $scope.results.$promise.finally(function () {
                $scope.searching = false;
                if ($scope.results.total > 0) {
                    $scope.searchOpen = true;
                }

            });
        };

        $scope.closeSearch = function() {
            $timeout(function(){
                $scope.searchOpen = false;
            }, 100  );
        };

        $scope.goToPathway = function(pathway) {
            var browseParams= encodeURIComponent(JSON.stringify({
                curriculum: pathway.root_curriculum,
                market: MarketOptionsConfig.getMarketById(pathway.root_market_id).slug,
                pathway_id: pathway.root_pathway_id,
                track_id: pathway.track_id,
                scroll_to: (pathway.further_sub_pathway_id ? pathway.further_sub_pathway_id : pathway.sub_pathway_id)
            }));

            redirect = '/find-picmonic?browse=app.pathways.market.' + pathway.root_pathway_type + '.tracks' + (pathway.track_id ? '.picmonics' : '') + '&browseParams='+browseParams+'&browseOptions=%7B"open":true%7D';

            if (UserService.user.user_id) {
                window.location = redirect;
            } else {
                UserService.showRegisterModal(false, redirect);
            }
        };
    }]);
